import { useQuery } from '@tanstack/react-query';

import { panelProviderQueries } from 'hooks/backend/panelProviders';

import FormSearchSelectInputV2 from '../../../common/forms/FormSearchSelectInputV2';

export const PartnerPanelProvider = () => {
  const { data: panelProviders = [] } = useQuery(panelProviderQueries.list());

  return (
    <FormSearchSelectInputV2
      name="audienceProfile.panelProvider"
      options={panelProviders}
    />
  );
};
